import { Github, Linkedin, Send, Twitter } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type SocialLink = {
  readonly label: string
  readonly href: string
  readonly icon: LucideIcon
  readonly external: boolean
}

/**
 * Social media links.
 * Update hrefs here — never in components.
 */
export const socialLinks: readonly SocialLink[] = [
  {
    label: 'GitHub',
    href: 'https://github.com/Hun49',
    icon: Github,
    external: true,
  },
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/company/hun-tech',
    icon: Linkedin,
    external: true,
  },
  {
    label: 'Telegram',
    href: 'https://t.me/huntechplc',
    icon: Send,
    external: true,
  },
  {
    label: 'X / Twitter',
    href: 'https://x.com/huntechplc',
    icon: Twitter,
    external: true,
  },
] as const
